<template>
  <div class="home">
    <div v-if="orderDetailInfo" class="main-content" @click="handleClick">
      <AppHead ref="head" title="Order details" :backFn="back"></AppHead>
      <div class="pc_content content">
        <!-- banner -->
        <banner :status="orderDetailInfo?.orderInfo?.orderStatus"></banner>
        <div class="marT">
          <!-- 回收流程 trade-in-process -->
          <trade-in-process :status="orderDetailInfo?.orderInfo?.orderStatus"></trade-in-process>
          <!-- 云检信息 -->
          <check :orderInfo="orderDetailInfo.orderInfo" @finalPriceClick="finalPriceClick"></check>
          <!-- 订单消息 -->
          <order-information :orderInfo="orderDetailInfo.orderInfo"></order-information>
          <!-- 物流信息 -->
          <logistics :logisticsInfo="orderDetailInfo.logisticsInfo"></logistics>
        </div>
      </div>
    </div>
    <!-- 弹窗 -->
    <btn-dialog ref="dialogRef" isCenter></btn-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import AppHead from '../../components/head';
import { orderAccept,orderDetail } from '../../services/api/brandList.js';
import { getParameterByName } from '../../utils/util';
import banner from './component/banner.vue';
import btnDialog from './component/btnDialog.vue';
import check from './component/check.vue';
import logistics from './component/logistics.vue';
import orderInformation from './component/orderInformation.vue';
import tradeInProcess from './component/tradeInProcess.vue';

export default {
  name: 'shippingLable',
  components: {
    btnDialog,
    logistics,
    check,
    tradeInProcess,
    orderInformation,
    banner,
    AppHead
  },
  data() {
    return {
      orderDetailInfo: {}
    };
  },
  computed: {
    ...mapState({
      isMaxScreen: state => state.isMaxScreen
    })
  },
  created() {
    this.getOrderDetail();
  },
  mounted() {},
  methods: {
    handleClick() {
      this.$refs.head.hidLangeList();
    },
    back() {
      window.location.reload();
    },
    finalPriceClick(type) {
      if (type == 1) {
        orderAccept()
          .then(res => {
            if (res.code == '0000') {
              this.$toast(this.$t('component.tradeInProcess.sureSuccess'));
              window.location.reload();
            }
          })
          .catch(() => {
            this.$toast(this.$t('component.tradeInProcess.submitError'));
          });
      }
      if (type == 2) {
        this.$refs.dialogRef.dialogVisible = true;
      }
    },
    getOrderDetail() {
      orderDetail()
        .then(res => {
          if (res.code == '0000') {
            this.orderDetailInfo = res.data;
          }
        })
        .catch(() => {});
    }
  }
};
</script>
<style scoped lang="less">
@media (max-width: 980px) {
  .home {
    width: 100%;
    min-height: 100%;
    background: #f7f7f7;
    .main-content {
      .content {
        padding-top:100px;
      }
    }
  }

  .marT {
    // margin-top: -120px;
  }

  h5 {
    color: var(---Text-1, #252629);
    font-family: 'PingFang SC';
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    padding: 32px;
    margin: 0;
    text-align: left;
  }

  .trade-in-process {
    width: 686px;
    // height: 412px;
    flex-shrink: 0;
    border-radius: 24px;
    background: #fff;
    margin: 0 auto;
    padding-bottom: 20px;

    .steps {
      display: flex;

      .step {
        position: relative;
        display: flex;
        flex-direction: column;
        flex: 1;
        padding: 10px;
        // justify-content: center;
        align-items: center;

        .step-line {
          position: absolute;
          width: 70px;
          right: -35px;
          top: 25px;
        }

        .step-icon {
          // width: 60px;
          height: 50px;
        }

        .step-title {
          color: #333;
          font-family: 'PingFang SC';
          font-size: 24px;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
          margin-top: 30px;
        }

        .step-content {
          color: #666;
          text-align: center;
          font-family: 'PingFang SC';
          font-size: 24px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          margin-top: 12px;
        }
      }
    }
  }
}

@media (min-width: 981px) {
  .home {
    width: 100%;
    min-height: 100%;
    background: #fff;
    .main-content {
    }
  }

  .pc_content {
    padding-top: 110px;
  }
}
/deep/ .el-dialog {
  .el-dialog__header {
    font-weight: bold;
    .el-dialog__headerbtn {
      .el-dialog__close {
        font-size: 20px;
        font-weight: bold;
        color: #000;
      }
    }
  }
  .el-dialog__footer {
    .dialog-footer {
      .el-button.el-button--primary {
        padding: 15px 20px;
        background-color: #ff9600;
        border-color: #ff9600;
        width: 100%;
      }
    }
  }
}
</style>
